const mobileScreen = window.matchMedia('(max-width: 764px)');
//mobile menu
const designList = document.querySelector('ul.design-process__list');
//mobile menu
const developmentList = document.querySelector('ul.development-process__list');

designList && designList.addEventListener('click', openServiceDetails);

developmentList &&
  developmentList.addEventListener('click', openServiceDetails);

export function openServiceDetails(e) {
  const $designProcessText =
    e.target.querySelector('#about-service') ||
    e.target.parentNode.querySelector('#about-service') ||
    e.target.parentNode.parentNode.querySelector('#about-service');
  if (mobileScreen.matches) {
    if (
      $designProcessText.style.display === 'none' ||
      !$designProcessText.style.display
    ) {
      $designProcessText.style.display = 'block';
    } else {
      $designProcessText.style.display = 'none';
    }
  }
}

import * as basicLightbox from 'basiclightbox';
//mobile menu
const list = document.querySelector('.our-works__list');

list && list.addEventListener('click', openProjectDetails);

export function openProjectDetails(e) {
  if (!mobileScreen.matches) return;
  const instance = basicLightbox.create(
    `
    <div id="modal">
        <a class="closeModal"></a>
        <p class="lightboxDescription">
            The sequence of website creation and a clear study of the stages is the key to the success of the entire project. It may seem to an ignorant user that website development is a trifling matter. Well, what's so difficult here - I came up with a design, made up, filled it with a couple of texts and you're done. In fact, each stage of website creation is a painstaking work, for which each developer from the web studio team is responsible.
        </p>
    </div>
`,
    {
      onShow: instance => {
        instance.element().querySelector('a').onclick = instance.close;
      },
    },
  );
  instance.show();
}
